import styled from 'styled-components';

export const StyledDibsContainer = styled.div`
  min-height: 1200px;
  margin-top: 40px;
`;